// ELIMINEX PEST SOLUTIONS - Mock Data

export const companyInfo = {
  name: "ELIMINEX",
  fullName: "Eliminex Pest Solutions",
  tagline: "Protection you can trust",
  founder: "Glynn Hardy",
  experience: "30",
  phone: "01522 468160",
  mobile: "07961 663483",
  phoneTel: "01522468160",
  mobileTel: "07961663483",
  email: "glynn@eliminexpestsolutions.co.uk",
  website: "www.eliminexpestsolutions.co.uk",
  serviceArea: "Lincolnshire",
  logo: "https://customer-assets.emergentagent.com/job_8a7f2b42-1e84-4152-94e9-4de05be1797d/artifacts/paumbl7c_Screenshot%202026-01-20%20at%2009.41.25.png",
  insurance: {
    fullyInsured: true,
    publicLiability: "£5 Million",
    professionalIndemnity: "£500,000"
  }
};

export const services = [
  {
    id: 1,
    title: "Bed Bug Control",
    description: "Our specialty. Expert treatment of bed bugs at all life stages using advanced techniques and eco-friendly solutions.",
    icon: "Bug",
    image: "https://images.unsplash.com/photo-1729294428628-6d97177fd053?crop=entropy&cs=srgb&fm=jpg&q=80&w=800",
    featured: true
  },
  {
    id: 2,
    title: "Rodent Control",
    description: "Effective rat and mouse control for homes and businesses. Complete removal and prevention strategies.",
    icon: "Mouse",
    image: "https://images.unsplash.com/photo-1768511526475-aebb7b521580?crop=entropy&cs=srgb&fm=jpg&q=80&w=800"
  },
  {
    id: 3,
    title: "Insect Control",
    description: "Cockroaches, ants, fleas, and more. Comprehensive insect treatment services.",
    icon: "Bug",
    image: "https://images.pexels.com/photos/12506311/pexels-photo-12506311.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: 4,
    title: "Wasp Treatment",
    description: "Fast Response: Same-day service for urgent wasp nest treatments across Lincolnshire.",
    icon: "Zap",
    image: "https://images.unsplash.com/photo-1748970445018-ed9bec19f227?crop=entropy&cs=srgb&fm=jpg&q=80&w=800"
  },
  {
    id: 5,
    title: "Commercial Services",
    description: "Tailored pest management plans for businesses, restaurants, hotels, and commercial properties.",
    icon: "Building2",
    image: "https://images.unsplash.com/photo-1760246964044-1384f71665b9?crop=entropy&cs=srgb&fm=jpg&q=80&w=800"
  },
  {
    id: 6,
    title: "Domestic Services",
    description: "Protecting your home and family from all types of pests with discreet, professional service.",
    icon: "Home",
    image: "https://images.unsplash.com/photo-1691829120775-0b56db1c2e0c?crop=entropy&cs=srgb&fm=jpg&q=80&w=800"
  },
  {
    id: 7,
    title: "Bird Control & Deterrents",
    description: "Professional bird control and deterrent systems. Netting, spikes, and humane solutions for pigeons and pest birds.",
    icon: "Bird",
    image: "https://images.unsplash.com/photo-1758963335840-4b16a106fdc9?crop=entropy&cs=srgb&fm=jpg&q=80&w=800"
  }
];

export const processSteps = [
  {
    step: 1,
    title: "Free Consultation",
    description: "Contact us to discuss your pest problem. We'll provide expert advice and arrange a convenient inspection time."
  },
  {
    step: 2,
    title: "Thorough Inspection",
    description: "Our experts conduct a comprehensive survey of your property to identify the extent of the infestation."
  },
  {
    step: 3,
    title: "Customised Treatment",
    description: "We create a tailored treatment plan using the most effective and safe methods for your situation, with follow-up visits where required."
  }
];

export const whyChooseUs = [
  {
    title: "30 Years Experience",
    description: "Three decades of professional pest control expertise you can rely on.",
    icon: "Award"
  },
  {
    title: "Bed Bug Specialists",
    description: "Industry-leading expertise in bed bug detection and elimination.",
    icon: "Target"
  },
  {
    title: "Fully Insured",
    description: "£5 Million public liability and £500,000 professional indemnity cover.",
    icon: "ShieldCheck"
  },
  {
    title: "Fast Response",
    description: "Quick call-outs and same-day service available across Lincolnshire.",
    icon: "Clock"
  },
  {
    title: "Eco-Friendly Methods",
    description: "Safe treatments for your family, pets, and the environment.",
    icon: "Leaf"
  },
  {
    title: "Proven Results",
    description: "A track record built on 30 years of effective pest control across Lincolnshire.",
    icon: "BadgeCheck"
  }
];

export const certifications = [
  {
    name: "NPTA",
    fullName: "National Pest Technicians Association",
    altText: "National Pest Technicians Association (NPTA) Member - Certified UK Pest Control",
    logo: "https://customer-assets.emergentagent.com/job_8a7f2b42-1e84-4152-94e9-4de05be1797d/artifacts/k27bjdc0_Screenshot%202026-01-19%20at%2017.22.50.png"
  },
  {
    name: "Basis Prompt",
    fullName: "Professional Pest Controller Register",
    altText: "BASIS PROMPT Registered Professional Pest Controller - UK Accredited",
    logo: "https://customer-assets.emergentagent.com/job_8a7f2b42-1e84-4152-94e9-4de05be1797d/artifacts/van56cdi_Screenshot%202026-01-19%20at%2017.24.19.png"
  },
  {
    name: "Bed Bug Foundation",
    fullName: "Certified Bed Bug Specialist",
    altText: "Bed Bug Foundation Certified Specialist - Professional Bed Bug Treatment Lincolnshire",
    logo: "https://customer-assets.emergentagent.com/job_8a7f2b42-1e84-4152-94e9-4de05be1797d/artifacts/ttnelx1l_Screenshot%202026-01-19%20at%2017.19.25.png"
  },
  {
    name: "Think Wildlife",
    fullName: "Campaign for Responsible Rodenticide Use",
    altText: "Think Wildlife - Campaign for Responsible Rodenticide Use (CRRU) Member",
    logo: "https://customer-assets.emergentagent.com/job_8a7f2b42-1e84-4152-94e9-4de05be1797d/artifacts/uyjpra1o_Screenshot%202026-01-20%20at%2011.14.31.png"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    location: "Lincoln",
    rating: 5,
    text: "Glynn was fantastic! After weeks of sleepless nights, Eliminex completely solved our bed bug problem. Highly professional and thorough."
  },
  {
    id: 2,
    name: "James T.",
    location: "Boston",
    rating: 5,
    text: "Used Eliminex for our restaurant's pest control contract. Reliable, discreet, and always available when we need them."
  },
  {
    id: 3,
    name: "Linda K.",
    location: "Grantham",
    rating: 5,
    text: "30 years experience really shows. Quick response, fair pricing, and the problem was sorted in no time. Excellent service!"
  }
];
